import { BodyDialogInternal, RowBnts, SpanQuestion } from "./DialogConfimStyle";
import {
  ButtonDefault,
  ButtonSecondary,
  CheckBox,
  TextAreaField
} from "components/shared/CustomInputs";
import { FormattedMessage, injectIntl } from "react-intl";
import React, { useEffect, useState } from "react";
import { candidatesActions, kindStages, pendingCandidateAction,bancoTalentosCandidateAction,contratarCandidateAction } from "../../../locale";
import {
  questionApproveCandidate,
  questionPendingCandidate,
  questionReproveCandidate,
  questionRemoveCandidate
} from "../../../locale/index";

import { LabelH1 } from "components/shared/CustomComponents";
import { Modal } from "react-bootstrap";

const DialogConfirm = ({
  intl,
  numberOfCandidates,
  requestToRegisterActions,
  show,
  closeDialog,
  setFeedBackText,
  kindOfAction,
  stageType,
}) => {
  const [enabledSendToCandidates, setEnabledSendToCandidates] = useState(false);
  const [textFeedBack, setTextFeedBack] = useState('');
  const APPROVED = candidatesActions[0].id;
  const DECLINE = candidatesActions[1].id;
  const TO_REMOVE = candidatesActions[2].id;
  const PENDING = pendingCandidateAction.id;
  const BANKOFTALENTS = bancoTalentosCandidateAction.id;
  const HIRE = contratarCandidateAction.id;

  const STAGE_FEEDBACK = kindStages[7].id;
  const STAGE_PRE_ADMISSION = kindStages[8].id;

  useEffect(() => {
    if ((stageType == STAGE_PRE_ADMISSION && kindOfAction == PENDING) || (stageType == STAGE_FEEDBACK)) {
      setEnabledSendToCandidates(true)
    }
  }, [stageType])

  const renderTitle = () => {
    if (kindOfAction == APPROVED) {
      return (<FormattedMessage id="sharedItems.confirmApprove" />);
    } else if (kindOfAction == DECLINE) {
      return (<FormattedMessage id="sharedItems.declineApprove" />);
    } else if (kindOfAction == PENDING) {
      return (<FormattedMessage id="sharedItems.pendingApprove" />);
    } else if (kindOfAction == BANKOFTALENTS) {
      return (<FormattedMessage id="sharedItems.bankofTalents" />);
    } else if (kindOfAction == HIRE) {
      return (<FormattedMessage id="sharedItems.hire" />);
    } else if (kindOfAction == TO_REMOVE) {
      return (<FormattedMessage id="sharedItems.confirmRemoval" />);
    } else {
      return (<FormattedMessage id="sharedItems.empty" />);
    }
  };

  const renderQuestion = () => {
    if (kindOfAction == APPROVED) {
      return questionApproveCandidate(numberOfCandidates)
    } else if (kindOfAction == DECLINE) {
      return questionReproveCandidate(numberOfCandidates)
    } else if (kindOfAction == PENDING) {
      return questionPendingCandidate(numberOfCandidates)
    } else if (kindOfAction == TO_REMOVE) {
      return questionRemoveCandidate(numberOfCandidates)
    } else {
      return ""
    }
  };

  const renderMessage = () => {
    if (stageType == STAGE_PRE_ADMISSION && kindOfAction == PENDING) {
      return (<FormattedMessage id="sharedItems.showfeedback" />);
    } else if (stageType == STAGE_FEEDBACK) {
      return (<FormattedMessage id="sharedItems.showfeedback" />);
    } else {
      return  (<FormattedMessage id="sharedItems.notFeedback" />);
    }
  }

  return (
    <Modal size="lg" show={show}>
      <Modal.Header>
        <LabelH1 fz="24px">
          {renderTitle()}
        </LabelH1>
      </Modal.Header>
      <Modal.Body>
        <BodyDialogInternal>
          <SpanQuestion>
            {renderQuestion()}
            {}
          </SpanQuestion>
          <TextAreaField
            placeholder={intl.formatMessage({
              id: "sharedItems.sendFeedBack"
            })}
            value={textFeedBack}
            onChange={event =>{ setFeedBackText(event.target.value); setTextFeedBack(event.target.value); }}
          />
           <p>{"Pelo menos 10 caracteres."}</p>
           <p>{renderMessage()}</p>
          <RowBnts>
            <ButtonSecondary
              name={<FormattedMessage id="sharedItems.no" />}
              onClick={() => closeDialog(false)}
              mr="20px"
              width="110px"
            />
            <ButtonDefault
              onClick={() => requestToRegisterActions(enabledSendToCandidates)}
              name={<FormattedMessage id="sharedItems.yes" />}
              width="110px"
              disabled={!textFeedBack || textFeedBack.length<10}
            />
          </RowBnts>
        </BodyDialogInternal>
      </Modal.Body>
    </Modal>
  );
};
export default injectIntl(DialogConfirm);
